export default {
  title: "Avue is a framework",
  tip: "tip",
  logoutTip: "Exit the system, do you want to continue?",
  submitText: "submit",
  cancelText: "cancel",
  search: "Please input search content",
  menuTip: "none menu list",
  input: "Please input ",
  select:'Please select',
  phone: "phone",
  code: "code",
  lodingText: "Loading, please wait",
  cityName: "Ningbo",
  headerTitle: "Ninghai digital breeding base",
  confirm:'Are you sure you want to select data deletion?',
  input_s: "Please select", //请选择
  message:'Successful operation',
  ok:'OK',
  cancel:'Cancel',
  back:'Back',
  weekday: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
  add:'Add',
  edit:'Edit',
  del:'Del',
  view:'View',
  weather: "en",
  more: "more",
  total: "Total",
  workshop: "Work",
  pool1: "Level 1 Pool",
  pool2: "Level 2 Pool",
  processed: "Processed",
  untreated: "Untreated",
  alarming: "Alarming",
  recovered: "Recovered",
  open: "Open",
  close: "Close",
  open1: "On",
  close1: "Off",
  empty:'No data',
  //首页
  wel: {
    title1: "Distribution in trophic stages",
    title2: "Production distribution",
    title3: "Trend of breeding days",
    title4: "Failure log",
    title5: "Alarm log",
    title6: "Inventory warning",
    title7: "Video surveillance",
    menu: ["Environment", "Signage", "Culture", "Feed", "Heat transfer"],
    yield: "Total yield",
    danwei: "/Mano",
    qs: "Total period",
    danwei2: "unit：day",
    danwei3: "unit：KG",
    timeOut:'timeout',
    normal:'normal',
    text:'Today',
    Death: {
      indicator: [
        {
          name: "Empty stomach",
          max: 1000,
        },
        {
          name: "Other",
          max: 1000,
        },
        {
          name: "Blue body",
          max: 1000,
        },
        {
          name: "Arch one's back",
          max: 1000,
        },
        {
          name: "Hepatopancreas",
          max: 1000,
        },
        {
          name: "Leukoplakia",
          max: 1000,
        },
        {
          name: "Redleg",
          max: 1000,
        },
        {
          name: "Heartbroken",
          max: 1000,
        },
      ],
      name: "治",
      series: [
        {
          data: [
            {
              value: [400, 400, 600, 600, 600, 600, 600, 600],
              name: "Stage 1",
            },
            {
              value: [800, 900, 900, 900, 900, 900, 900, 900],
              name: "Stage 2",
            },
            {
              value: [900, 1000, 400, 400, 400, 400, 0, 400],
              name: "Stage 3",
            },
          ],
        },
      ],
    },
  },
  //车间全景
  work: {
    menu: ["Workshop", "Operation", "Device", "Video", "Power", "Back Home"],
    title1: "Culture data",
    title2: "Real-time alarm statistics",
    title3: "Real-time fault statistics",
    title4:"back-wash dialog",
    legend: [
      "Blowdown",
      "Loop",
      "Deflate",
      "Oxygen",
      "Water",
      "Alarm",
      "Fault",
    ],
    fault: {
      title: "Fault",
      Time: "Time",
      info: "Info",
      type: "Type",
      address: "Address",
      picture: "Picture",
      status: "Status",
    },
    alarm: {
      title: "Alarm",
      id: "ID",
      Time: "Time",
      info: "Info",
      type: "Type",
      address: "Address",
      status: "Status",
    },
    DO: "DO",
    PH: "PH",
    TEMP: "Temp",
    LC: "LC",
    blowdown: "Blowdown",
    Loop: "Loop",
    GasExplosion: "Gas",
    Oxygen: "Oxygen",
    water: "PushWater",
    assets: "List of assets",
    usable: "usable",
    available: "NotAvailable",
    pond: "Pond(big)",
  },
  //运行监测
  running: {
    legend: [
      "Blowdown",
      "Loop",
      "Deflate",
      "Oxygen",
      "Water",
      "Started",
      "Unstart",
    ],
    dialogTitle: "Batch operation",
    assets: "List of breeding ponds",
    placeholder: "Please input device name",
    reset: "Reset",
    ok: "OK",
  },
  //设备管理
  device: {
    legend: ["Alarm", "Fault", "Started", "Unstart"],
    btnTitle: "Pump",
    selectData: [
      "Sand filtration",
      "Egg fraction",
      "Microfiltration",
      "Biochemistry",
    ],
    stress: "Stress",
    backwash: "Today backwash",
    voltage: "Voltage",
    slData: ["Water pump", "A Valve", "B Valve", "C Valve"],
    dfData: ["Circulating pump", "Cleaning valve", "Ozone"],
    title1: "Device status data",
    title2:'Device Overview',
    message: "Successful operation",
  },
  //视频监测
  video: {
    pagination: {
      pageSize: "Items per page",
      total: "Total",
      items: "items",
      prev: "Previous",
      next: "Next",
      jumper: "Go to",
      pager: "Page",
    },
    situation: "Real-time overview",
    recording: "playback",
    Monitor: "Monitor list",
    control: "PTZ control",
    move: "Speed",
    focusing: "Focus",
    focusing1: "Focus",
    aperture: "Light",
    title: "Video search",
    start: "Start Time：",
    end: "End Time：",
  },
  //配电管理
  power: {
    title1: "Power utilization rate",
    title2: "Overall operation",
    title3: "Temp and humidity",
    title4: "Exception log message",
    title5: "Input voltage",
    title6: "Output voltage",
    yAxisName1: "Temp:℃ Humid:%",
    yAxisName2: "Unit：%",
    label: ["Day", "Month"],
    headTitle: "Electricity Name",
    headInfo: "Log Info",
    headTime: "Occurrence Time",
  },
  //养殖看板
  CultureData: {
    menu: ["CultureData", "Analysis", "Yield", "Fodder", "Back Home"],
    Statistics: {
      text: "Periods",
      text1: "Seeding",
      text2: "Mano",
      text3: "Yield",
      text4: "KG",
      text5: "Earnings",
      text6: "￥",
      text7: "Base",
      text8: "ThisYear",
      text9: "Workshop",
    },
    work: {
      text1: "Period of the year",
      text2: "Successful phase",
      text3: "Seeding this year",
      text4: "This year harvest",
      jdName: "Stage 1",
      jdName2: "Stage 2",
      jdName3: "Stage 3",
    },
    title: "Patrol log",
    title1: "Growth log",
    date:'Patrol Date',
    workShop:'Workshop',
    user:'Patrol User',
    result:'Patrol Result',
    date1:'Test Date',
    workShop1:'Workshop',
    user1:'Test User',
    result1:'Test Result'
  },
  //养殖看板=》养殖车间
  breeding:{
    menu:['Workshop','Back'],
    text:'Seeding this year',
    text1:'This year harvest',
    text2:'Eliminated this year',
    text3:'Period of the year',
    text4:'Successful phase',
    text5:'Phase-out period',
    text6:'Breeding stages',
    progress:{
        type:'Type',
        number:'Seeding Num',
        date:'Seeding Date',
        day:'Day'
    },
    harvest:'Harvest',
    seeding:'Seeding',
    culture:'Culture',
    success:'Success',
    lose:'Lose',
    title:'Historical period',
    title2:'Water quality detection',
    data:[
        {
          name: "yy",
          value: "yy",
        },
        {
          name: "ad",
          value: "ad",
        },
        {
          name: "yl",
          value: "yl",
        },
        {
          name: "PH",
          value: "ph",
        },
        {
          name: "ORP",
          value: "orp",
        },
        {
          name: "hhs",
          value: "hhs",
        },
        {
          name: "hhx",
          value: "hhx",
        },
        {
          name: "lhs",
          value: "lhs",
        },
        {
          name: "lhx",
          value: "lhx",
        },
      ],
      yy:'yy',
      ad:'ad',
      yl:'yl',
      ph:'PH',
      orp:'ORP',
      hhs:'hhs',
      hhx:'hhx',
      lhs:'lhs',
      lhx:'lhx',
  },
  //养殖看板=》养殖期数详情
  periods:{
    menu:['Periods','Compare','Back'],
    qsInfo:{
        seeding:'Seedlings/Mano',
        day:'Breeding days',
        phase:'Culture stage',
        qs:'Number of breeding stage',
        type:'Culture type',
        status:'Culture status',
        work:'Culture workshop',
        user:'Person in charge',
        supplier:"Supplier",
        date:'Seeding date',
        harvest:'Expected harvest',
    },
    title:'Water quality analysis',
    title1:'Feed',
    title2:'Growth analysis',
    title3:'Seedling transfer information',
    title4:'Patrol log',
    title5:'Breeding photo',
    day:'Days',
    name:'Name',
    danwei:'Feed num/g',
    day1:'Day {day}',
    danwei1:'Weight/kg',
    danwei2:'Number of seedlings/tail',
    danwei3:'yield/%',
    title6:'Photo details',
  },
  //数据对比
  DataComparison:{
    title:'Data index',
    title1:'Periods',
    placeholder:'Please select a data indicator',
    placeholder1:'Please select the number of sessionsr',
    reset:'Reset',
    analyze:'Analyze',
  },
  //产量分析
  yield:{
    title:'Total output this year(KG)',
    text:'Total yield/KG',
    text1:'Present periods',
    text2:'Total periods',
    title1:'Factory shrimp fry',
    title2:'Breeding details over the years',
    title3:'The proportion of workshop breeding',
    title4:'Monthly fry',
    title5:'Shrimp record',
    danwei:'Unit：Mano',
    danwei1:'Unit：KG',
    danwei2:'Total output(KG)',
    danwei3:'Total period',
    date:'Date',
    xz:'Shrimp seed',
    danwei4:'Harvest(KG)',
    danwei5:'Price(￥/KG)',
    index:"index",
    type:"type",
    total:"Feeding amount (g)",
  },
  //饲料分析
  fodder:{
    title:'Shop feed volume',
    title1:'Monthly feeding quantity',
    title2:'Monthly animal protection',
    title3:'Factory feed',
    title4:'Purchasing analysis',
    title5:'Phase feeding amount (under care)',
    title6:'Monthly consumption',
    title7: "Feeding record",
    text:'Fodder',
    text1:'Dosage',
    text2:'Total consumption/kg this year',
  },
  //养殖循环
  CultureCycle:{
    menu:['Culture cycle','Project','Conduit','Northern','Back Home'],
    title:'One-unit cycle',
    name:'Ultraviolet antivirus',
    name1:'Biochemical pool',
    name2:'Egg fraction',
    name3:'Culture pond',
    name4:'Clean water basin',
    name5:'Microfiltration',
    run:'Run',
    stop:'Stop',
    gas:'Gas',
    oxygen:'Oxygen',
    pump:'Pump',
    backwash:'Backwash',
    loop:'Loop',
    blowdown:'Blowdown',
    pwf:'Blow-down valve',
    xhf:'Circulating valve',
  },
  //源水总规，一级、二级蓄水池
  pool:{
    title:'Buffer pool water level',
    title1:'Source pool level',
    title2:'Pump condition',
    title3:'Sand filter pressure',
    text:'Start scheduling',
    text1:'Stop scheduling',
    text2:'Start-up time',
    text3:'Leisure',
    text4:'Water/Disinfect',
    text5:'Usable',
    text6:'Fault/Clear',
    name:'Float switch',
    name1:'Clear',
    name2:'Normal',
    name3:'Disinfect',
    name4:'Stop',
    data:['Boiler outlet valve','Boiler return valve','Source water inlet valve','Shop inlet valve','Residual outlet valve','Waste flooding valve','Float switch'],
    data1:['Inlet electric valve','Outlet valve','Add CIO2 valve','Float switch'],
    name5:'Heating',
    name6:'Watering',
  },
  //源水管道，水泵房
  conduit:{
    legend:['Backwash','Started','Unstart'],
    name:'Southern flooding',
    name1:'Connectivity pool',
    name2:'Source pool',
    name3:'Liquid level gauge',
    name4:'Northern influent',
    name5:'Northern',
    pump:'Recoil pump',
    pump1:'Blowdown pump',
    valve:'Backflush valve',
    text:'In',
    text1:'Out',
    text2:'Pump',
    text3:'A',
    text4:'B',
    text5:'C',
    text6:'Press',
  },
  //饲料投喂
  feed:{
    menu:['Auto feeding','Car manage','Route manage','Feeding plan','Back Home'],
    title:'Robot profile',
    title1:'feeding frequency',
    title2:'Feeding profile',
    title3:'Electricity profile',
    name:'Robot',
    name1:'Daily feed',
    name2:'Week feed',
    name3:'Month feed',
    name4:'Daily power',
    name5:'Week power',
    name6:'Month power',
  },
  //小车管理
  car:{
    title:'ID',
    title1:'Car Name',
    title2:'Status',
    placeholder:'Please enter the number',
    placeholder1:'Please enter the name',
    placeholder2:'Please select the status',
    button:'Reset',
    button1:'Search',
    button2:'Save',
    button3:'Cancel',
    statusData: [
      { label: "leisure", value: 1 },
      { label: "runing", value: 2 },
      { label: "Charging", value: 3 },
      { label: "fault", value: 4 },
    ],
    index:'#',
    column:{
      label:'ID',
      label1:'Car name',
      label2:'Workshop',
      label3:'Feeding frequency',
      label4:'Power(%)',
      label5:'Status',
    },
    text:'Car info',
    status:'Runing',
    status1:'leisure',
    status2:'Charging',
    status3:'fault',
    message:'Successful operation',
  },
  //路线管理
  line:{
    title:'Name',
    placeholder:'Please input name',
    title1:'Route information',
    column:{
      label:'Name',
      label1:'Workshop',
      label2:'Feeding point',
      label3:'Feeding direction'
    },
    data:{
      name1:'No.1 feeding pool',
      name2:'No.2 feeding pool',
      name3:'No.3 feeding pool',
      name4:'No.4 feeding pool',
      name5:'No.5 feeding pool',
      name6:'No.6 feeding pool',
      name7:'No.7 feeding pool',
      name8:'No.8 feeding pool',
      name9:'No.9 feeding pool',
      name10:'No.10 feeding pool',
      name11:'No.11 feeding pool',
      name12:'No.12 feeding pool',
      direction:'Left',
      direction1:'Right',
    },
  },
  //投喂计划
  plan:{
    title:'Name',
    title1:'Plan info',
    column:{
      label:'Project name',
      label1:'Workshop',
      label2:'Feeding time',
      label3:'Feeding timetable',
      label4:'Feeding rate',
      label5:'Status'
    },
    statusData: [
      { label: "Running", value: "运行" },
      { label: "Stop", value: "停止" },
    ],
    data:{
      name:'Car 1',
      name1:'Car 2',
      name2:'Car 3',
      time:'Everyday',
      status:'Running',
      status1:'Stop',
      text:'Feeding list'
    },
  },
  //告警日志
  alarm:{
    menu:['Alarm log','Back'],
    radioData: [
      {
        label: "Current alarm",
        value: "1",
      },
      {
        label: "Historical alarm",
        value: "2",
      },
    ],
    search:{
      title:'Time',
      title1:'Type',
      title2:'Level',
      title3:'Address',
      startPlaceholder:'Start Date',
      endPlaceholder:'End Date',
      rangeSeparator:'to'
    },
    column:{
      text:'Normal',
      text1:'Intermediate',
      text2:'Urgent',
      text3:'Alarming',
      text4:'Recovered',
      text5:"expired",
      title:'Alarm details',
      title1:'Alarm info',
      level:'Alarm level',
      label:'Alarm time',
      label1:'Alarm ID',
      label2:'Alarm description',
      label3:'Alarm type',
      label4:'Alarm level',
      label5:'Alarm location',
      label6:'Recovery time',
      label7:'Alarm status',
    },
  },
  //故障日志
  fault:{
    menu:['Failure log','Back'],
    search:{
      title:'Time',
      title1:'Type',
      title2:'Level',
      title3:'Address',
      title4:'Status',
      title5:'User'
    },
    radioData: [
      {
          label: "Fault of the day",
          value: "0",
        },
        {
          label: "Unhandled fault",
          value: "1",
        },
        {
          label: "Handled fault",
          value: "2",
        },
      ],
      column:{
        title:'Fault details',
        title:'Fault info',
        label:'Fault time',
        label1:'Fault description',
        label2:'Fault type',
        label3:'Fault level',
        label4:'Fault location',
        label5:'Recovery time',
        label6:'Fault state',
        label7:'Processor',
        label8:'Fault image',
        text:'Unhandled',
        text1:'Paused',
        text2:'Canceld',
        taxt3:'Completed',
        text4:'Processing information',
        text5:'Processing time',
        text6:'Processing personnel',
        text7:'Process description',
        text8:'Process image'
      },
  },
  //换风换热
  heat:{
    menu:['Heat pump','Boiler','Fresh air','Back Home'],
    title:'Magnetic levitation water source heat pump heat exchange system',
    //车间新风
    air:{
      label:'Air volume',
      label1:'Humidness',
      label2:'Temp',
      title:'CO2 statistics',
      title1:'CO2 concentration',
      title2:'Device status data',
    },
  },
  //一级蓄水池
  pool_1:{
    menu:['Master gauge','Sand filtration','Egg fraction','Conduit','North District','Back Home'],
  },
  //二级蓄水池
  pool_2:{
    menu:['Hot water','Conduit','Boiler heating','Waste heat','Back Home'],
    text:'Add water',
    title:'Inlet pump details',
    title1:'Discharge pump details',
    message:'Are you sure you want to set it to clean?',
    message1:'Are you sure you want to set it to fault?',
    message2:'Are you sure you want to go back to normal?',
    message3:'Are you sure you want to disinfect?',
    message4:'Are you sure to cancel the disinfection?',
  },
  route: {
    info: "info",
    website: "website",
    avuexwebsite: "avuex",
    dashboard: "dashboard",
    more: "more",
    tags: "tags",
    store: "store",
    permission: "permission",
    api: "api",
    logs: "logs",
    table: "table",
    form: "form",
    top: "backtop",
    data: "data",
    error: "error",
    test: "test",
  },
  login: {
    title: "Ninghai Breeding Base",
    info: "Enterprise Development Platform",
    phone: "Phone",
    phonePlaceholder: "Please input phone",
    tenantId: "Please input tenantId",
    username: "Please input username",
    password: "Please input a password",
    gitee: "gitee",
    code: "Code",
    codePlaceholder: "Please input code",
    submit: "Login",
    userLogin: "userLogin",
    phoneLogin: "phoneLogin",
    msgText: "send code",
    msgSuccess: "reissued code",
    loginBtn: "Login",
    successMssage: "The verification code is sent successfully",
    Technology: "Atomic Equation Technology (Shenzhen) Co., LTD",
    loding: "Login, please wait...",
  },
  navbar: {
    info: "info",
    logOut: "logout",
    userinfo: "userinfo",
    dashboard: "dashboard",
    lock: "lock",
    bug: "none bug",
    bugs: "bug",
    screenfullF: "exit screenfull",
    screenfull: "screenfull",
    language: "language",
    notice: "notice",
    theme: "theme",
    color: "color",
  },
  tagsView: {
    search: "Search",
    menu: "menu",
    clearCache: "Clear Cache",
    closeOthers: "Close Others",
    closeAll: "Close All",
  },
  yzfcWork: {
    name: "work name",
  },
  printing: {
    feedingList: "Feeding list", //投喂清单
    code: "Code", //期数
    days: "Days", //天数
    date: "Date", //日期
    workshop: "Workshop", //车间
    personnel: "Feeding personnel", //投喂人员
    time: "Time", //时刻
    pond: "Pond", //养殖池
    feed: "Feed(g)", //饲料(g)
    mixingMaterials: "Mixing materials", //拌料
    mixingWater: "Mixing water(g)", //拌水(g)
    total: "Total(g)", //合计(g)
    total1: "Planned total", //合计(g)
    total2: "Actual total", //合计(g)
    prawnCracker: "Prawn cracker", //虾片
    crushedMaterial03: "0.3 Crushed material", //0.3破碎料
    seedlingMaterial1: "Seedling material I", //I号苗料
    crushedMaterial05: "0.5 Crushed material", //0.5破碎料
    seedlingMaterial2: "Seedling material II", //II号苗料
    crushedMaterial08: "0.8 Crushed material", //0.8破碎料
    seedlingMaterial3: "Seedling material III", //III号苗料
    crushedMaterial10: "1.0 Crushed material", //1.0颗粒料
    remark: "Remark", //备注
  },
  sjzx: {
    export: "Export", //导出
    download: "Download now", //点击下载文件
    exporting: "Exporting,please stand by...", //文件导出生成中,请等待...
    //水质记录
    szjl: {
      time: "Time", //监测时间
      code: "Code", //养殖期数
      days: "Days", //养殖天数
      workshop: "Workshop", //养殖车间
      pond: "Pond", //养殖池
      do: "Do", //溶氧
      ph: "PH", //PH值
      temperature: "Temperature", //温度
      liquidLevel: "liquid level" //液位
    },
    //生长记录
    scjl: {
      time: "Time", //检测时间
      code: "Code", //养殖期数
      days: "Days", //养殖天数
      workshop: "Workshop", //养殖车间
      pond: "Pond", //养殖池
      length: "Length(mm)", //体长(mm)
      weight: "Weight(g)", //体重(g)
      color: "Color", //体色
      growthMomentum: "Growth momentum", //目前长势(尾)
      illness: "Illness", //虾体病况
      death: "Death", //死虾情况
      status: "Status", //虾体状态
      personnel: "Personnel" //检测人员
    },
    //检测记录
    jcjl: {
      time: "Time", //检测时间
      code: "Code", //养殖期数
      days: "Days", //养殖天数
      workshop: "Workshop", //养殖车间
      pond: "Pond", //养殖池
      subsalt: "Subsalt", //亚盐
      ammoniaNitrogen: "Ammonia nitrogen", //氨氮
      residualChlorine: "Residual chlorine", //余氯
      PH: "PH", //PH
      ORP: "ORP", //ORP
      VibrioFlavus_w: "Vibrio flavus(w)", //黄弧(水)
      VibrioFlavus_s: "Vibrio flavus(s)", //黄弧(虾)
      greenVibrio_w: "Green Vibrio(w)", //绿弧(水)
      greenVibrio_s: "Green Vibrio(s)", //绿弧(虾)
      personnel: "Personnel", //检测人员
      custom:'Custom detection object', //自定义检测对象
    },
    //投喂记录
    twjl: {
      complete: "Completed", //已完成
      incomplete: "Incomplete", //未完成
      inProgress:'inProgress',
      date: "Date", //投喂日期
      code: "Code", //养殖期数
      days: "Days", //养殖天数
      workshop: "Workshop", //养殖车间
      pond: "Pond", //养殖池
      time: "time", //时刻
      prawnCracker: "Prawn cracker(g)", //虾片(g)
      seedlingMaterial1: "Seedling material I(g)", //I号苗料(g)
      seedlingMaterial2: "Seedling material II(g)", //II号苗料(g)
      seedlingMaterial3: "Seedling material III(g)", //III号苗料(g)
      crushedMaterial03: "0.3 Crushed material(g)", //0.3破碎料(g)
      crushedMaterial05: "0.5 Crushed material(g)", //0.5破碎料(g)
      crushedMaterial08: "0.8 Crushed material(g)", //0.8破碎料(g)
      crushedMaterial10: "1.0 Crushed material(g)", //1.0颗粒料(g)
      mixingMaterials: "Mixing materials", //拌料
      mixWeight: "Mix weight(g)", //拌料数量(g)
      mixingWater: "Mixing water(g)", //拌水(g)
      personnel: "Personnel", //投喂人员
      status: "Status", //投喂状态
      bl1:'Mix 1',     //拌料1
      sl1:'Mix 1 Quantity (g)',   //拌料1数量(g)
      bl2:'Mix 2',     //拌料2
      sl2:'Mix 2 Quantity (g)',   //拌料2数量(g)
      bl3:'Mix 3',     //拌料3
      sl3:'Mix 3 Quantity (g)',   //拌料3数量(g)
      bl4:'Mix 4',     //拌料4
      sl4:'Mix 4 Quantity (g)',   //拌料4数量(g)
      startTime:'Start time',   //开始时间
      endTime:'End time',   //结束时间
      types:'Type',   //养殖种类
      feedType:'Feed type',   //饲料类型
      feedCode:'Feed number' ,   //饲料编号
      feedName:'Feed name',   //饲料名称
      planTotal:'Planned usage',   //计划用量
      sjTotal:'actual usage',   //实际用量
    },
    //数据对比
    sjdb: {
      empty: "Empty", //重置
      dataIndicators: "Indicators", //数据指标
      code: "Code", //养殖期数
      analysis: "Data analysis" //数据分析
    },
    slxh:{
      date:'Breeding date',
      yzzl:"Types of aquaculture",
      yzDays:"Breeding days",
      status:"Breeding status",
      work:"Breeding workshop",
      yzjd:"Breeding stage",
      sllx:"Feed type",
      slbh:"Feed number",
      slmc:"Feed Name",
      sjyl:"actual usage(g)",
      xj:"subtotal(g)",
      total:"total(g)"
    }
  },
  wljDetail:{
    title:'Equipment Overview',
    title1:'alarm',
    title2:'fault',
    title3:'Backwash log',
    
  }
};
